module.exports = __webpack_public_path__ + "static/img/中雨.0fa18f45.svg";